import React from "react";
import logo from "../../../assets/images/logo_black.png";
import BubbleSvgButton from "../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import "./PublicVerifiedTradeHeader.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicVerifiedTradeHeader = () => {
  const navigate=useNavigate();
  const user=useSelector(state=>state?.user)
  return (
    // <div className="custom-container">
      <div style={{width:"100%"}} className="custom-container publicHeaderWrap d-flex justify-content-between align-items-center">
        <div>
          <img src={logo} alt="logoImg" className="publicVerifiedLogo" />
        </div>
        <div onClick={()=>{
          if(user.user){
            navigate("/leader/verifiedTrading")
            return;
          }
          navigate("/login")}}>
          <BubbleSvgButton
            text="Verify a Trade"
            className="publicVerifyTradeBtn"
            type="button"
            variant="black"
            containerStyling={{
              justifyContent: "center",
            }}
            mainDivStyle={{
              width: "auto",
              height: "auto",
            }}
          />
        </div>
      </div>
    // </div>
  );
};

export default PublicVerifiedTradeHeader;
